import { render, staticRenderFns } from "./team-detail.vue?vue&type=template&id=13c085a7&scoped=true"
import script from "./team-detail.vue?vue&type=script&lang=js"
export * from "./team-detail.vue?vue&type=script&lang=js"
import style0 from "./team-detail.vue?vue&type=style&index=0&id=13c085a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c085a7",
  null
  
)

export default component.exports